// import { getFormFields } from './gift-love-personalised-form-configs.js';

const PAGE_WIDTH = 300;
const PAGE_HEIGHT = PAGE_WIDTH * 1.4;
const SIDE_MARGIN = 16;
const LINE_HEIGHT = 14;

const PDF_PRODUCTS = {
    '14886526747001': 'anniversary',
    '14889238495609': 'birthday2',
    '14889239282041': 'birthday3'
};

class GiftLoveUpsellProductDetail extends CoreElement {
    constructor() {
        super();
    
        const sheet = new CSSStyleSheet();
        this.shadow.adoptedStyleSheets = [sheet];
    }

    state = { 
        personalisation_fields: [],
        isLoading: false 
    }

    connectedCallback() {
        const isGiftCard = this.getAttribute('is_gift_card') === '1';
        
        // Only set loading state if not a gift card
        if (!isGiftCard) {
            this.setState({ isLoading: true });
        }
        
        this.renderHTML();

        const trimmedContent = this.innerHTML.trim();
        try {
            const personalisation_fields = JSON.parse(trimmedContent);
            this.setState({ personalisation_fields });
            console.log('Parsed personalisation_fields:', personalisation_fields);
        } catch (e) {
            console.error('Error parsing innerHTML:', e);
            console.log('Failed content:', trimmedContent);
        }

        // Only fetch personalization fields if not a gift card
        if (!isGiftCard) {
            this.fetchPersonalizationFields();
        } else {
            // For gift cards, we don't need to fetch fields
            this.setState({ isLoading: false });
        }
    }

    static get observedAttributes() {
        return ['url', 'css', 'product_id', 'variant_id', 'image', 'title', 'price', 'all_images', 'is_gift_card', 'product_handle'];
    }

    async fetchPersonalizationFields() {
        try {
            const productHandle = this.getAttribute('product_handle');
            if (!productHandle) {
                console.warn('Product handle not provided');
                this.setState({ isLoading: false });
                return;
            }

            const response = await fetch('https://puppeteer-cgl.personify.tech/api/get-personalization-fields', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    handle: productHandle
                })
            });

            const result = await response.json();
            if (result.success && result.data) {
                this.setState({ 
                    personalisation_fields: result.data,
                    isLoading: false 
                });
                this.renderHTML(); // Re-render with new fields
            }
        } catch (error) {
            console.error('Error fetching personalization fields:', error);
            this.setState({ isLoading: false });
            this.renderHTML();
        }
    }

    async fetchFormFields() {
        try {
            const response = await fetch(`/api/product-options/${this.getAttribute('product_id')}`);
            const data = await response.json();
            return data.options;
        } catch (error) {
            console.error('Error fetching form fields:', error);
            return null;
        }
    }

    renderFormFields = () => {
        const isGiftCard = this.getAttribute('is_gift_card') === '1';
        
        if (this.state.isLoading && !isGiftCard) {
            return `
                <div class="loading-container">
                    <div class="loading-spinner"></div>
                    <p class="loading-text">Loading personalization options...</p>
                </div>
            `;
        }

        if (isGiftCard) {
            return `
                <div class="row js message-preview-container">
                    <div class="option-selector">
                        <div class="form-group">
                            <label for="option_message">Message</label>
                            <div class="message-preview">
                                <div 
                                    class="editable-content" 
                                    contenteditable="true"
                                    data-placeholder="Type your message here..."
                                    data-max-length="450"></div>
                                <input type="hidden" 
                                    class="message-input"
                                    id="option_message"
                                    name="properties[Message]">
                            </div>
                            <div class="character-count">
                                <span class="current">0</span> of 450 characters
                            </div>
                        </div>
                    </div>
                </div>
                <button type="submit" class="add-to-cart-button">Add to Cart</button>
            `;
        }

        const fields = this.state.personalisation_fields;
        let formFieldsHtml = fields.map(field => {
            if (field.type === 'text') {
                return `
                    <div class="row js">
                        <div class="option-selector">
                            <div class="form-group">
                                <label for="option_${field.label}">${field.label}${field.required ? ' *' : ''}</label>
                                <input type="text" 
                                    id="option_${field.label}" 
                                    name="properties[${field.label}]"
                                    ${field.required ? 'required' : ''}
                                    ${field.maxLength ? `maxlength="${field.maxLength}"` : ''}>
                            </div>
                        </div>
                    </div>
                `;
            } else if (field.type === 'select') {
                return `
                    <div class="row js">
                        <div class="option-selector" data-single-option-selector data-selector-type="dropdown">
                            <div class="cc-select">
                                <label for="option_${field.label}" class="label">${field.label}${field.required ? ' *' : ''}</label>
                                <select id="option_${field.label}" 
                                    name="properties[${field.label}]"
                                    ${field.required ? 'required' : ''}>
                                    <option value="">Select ${field.label}</option>
                                    ${field.values.map(value => `
                                        <option value="${value.value}">${value.label}</option>
                                    `).join('')}
                                </select>
                            </div>
                        </div>
                    </div>
                `;
            }
            return '';
        }).join('');

        formFieldsHtml += `<button type="submit" class="add-to-cart-button">Add to Cart</button>`;
        return formFieldsHtml;
    }

    renderHTML = async () => {
        this.style.cssText = this.renderContainerStyle();
        const formFieldsHtml = await this.renderFormFields();
        
        const html = `
            ${this.renderStyle()}
            <div class="popup-container">
                <button class="close-button">×</button>
                <div class="product-detail">
                    <img src="${this.getAttribute('image')}" alt="${this.getAttribute('title')}" id="product-image">
                    <div class="product-info">
                        <h3>${this.getAttribute('title')}</h3>
                        <p class="price">£${(Number(this.getAttribute('price')) / 100).toFixed(2)}</p>
                        
                        <form id="personalisation-form">
                            ${formFieldsHtml}
                        </form>
                    </div>
                </div>
                <a href="#" class="continue-shopping">Continue shopping</a>
            </div>
        `;
        this.shadow.innerHTML = html;

        // Add event listeners
        this.shadow.querySelector('.close-button').addEventListener('click', () => {
            console.log('Close button clicked in product detail popup');
            this.remove();
        });

        this.shadow.querySelector('.continue-shopping').addEventListener('click', (e) => {
            e.preventDefault();
            console.log('Continue shopping clicked in product detail popup');
            
            console.log('Removing product detail popup from continue shopping button without changing product status');
            this.remove();
        });

        this.shadow.querySelector('#personalisation-form').addEventListener('submit', (e) => {
            e.preventDefault();
            this.handleAddToCart();
        });

        // Add message preview functionality
        this.setupMessagePreview();
    }

    setupMessagePreview() {
        const messageInput = this.shadow.querySelector('.editable-content');
        const hiddenInput = this.shadow.querySelector('input[name="properties[Message]"]');
        const characterCount = this.shadow.querySelector('.character-count .current');
        const productImage = this.shadow.querySelector('#product-image');
        
        if (messageInput && hiddenInput) {
            messageInput.addEventListener('input', (e) => {
                const text = messageInput.textContent;
                const maxLength = parseInt(messageInput.dataset.maxLength);
                
                // Add or remove class based on whether there's text
                if (text.length > 0) {
                    productImage.classList.add('shrink-image');
                    messageInput.dataset.empty = 'false';
                } else {
                    productImage.classList.remove('shrink-image');
                    messageInput.dataset.empty = 'true';
                }
                
                if (text.length > maxLength) {
                    messageInput.textContent = text.substring(0, maxLength);
                    const range = document.createRange();
                    const sel = window.getSelection();
                    range.selectNodeContents(messageInput);
                    range.collapse(false);
                    sel.removeAllRanges();
                    sel.addRange(range);
                    characterCount.textContent = maxLength;
                } else {
                    characterCount.textContent = text.length;
                }
                
                hiddenInput.value = messageInput.innerHTML;
            });

            messageInput.addEventListener('focus', () => {
                messageInput.dataset.empty = 'true';
                productImage.classList.add('shrink-image');
            });

            messageInput.addEventListener('blur', () => {
                const text = messageInput.textContent.trim();
                if (text === '') {
                    messageInput.dataset.empty = 'true';
                    productImage.classList.remove('shrink-image');
                } else {
                    messageInput.dataset.empty = 'false';
                }
            });
        }
    }

    handleAddToCart = async () => {
        const form = this.shadow.querySelector('#personalisation-form');
        const formData = new FormData(form);
        const properties = {};
        
        formData.forEach((value, key) => {
            if (key.startsWith('properties[')) {
                const propName = key.slice(11, -1);
                properties[propName] = value;
            }
        });

        const productId = this.getAttribute('product_id');
        const isGiftCard = this.getAttribute('is_gift_card') === '1';
        
        if (isGiftCard) {
            console.log('Processing gift card product...');
            const pdfCode = Math.random().toString(36).substring(2, 15);
            properties['Card Number'] = pdfCode;
            properties['_is_gift_card'] = 'true';
            
            // Store the image URL as a hidden property for future edits
            const giftCardImageUrl = this.getAttribute('gift_card_front_image') ? 'https:' + this.getAttribute('gift_card_front_image') : null;
            properties['_gift_card_image_url'] = giftCardImageUrl;
            
            const pdfUrl = `https://print-manager-media.s3.eu-west-1.amazonaws.com/puppeteer/polotno-cgl/${pdfCode}.pdf`;
            properties['PDF Link'] = pdfUrl;
            
            let message = properties['Message'] || '';
            
            // Convert HTML message to plain text with proper line breaks
            message = message
                .replace(/<div>/gi, '\n')  
                .replace(/<\/div>/gi, '')  
                .replace(/<br\s*\/?>/gi, '\n')  
                .replace(/&nbsp;/gi, ' ')  
                .replace(/<[^>]*>/g, '')   
                .trim()                    
                .replace(/\n{3,}/g, '\n\n'); 

            const imageType = PDF_PRODUCTS[productId];

            properties['Message'] = message;
            
            const payload = {
                message: message,
                imageType: imageType || 'default',
                imageUrl: this.getAttribute('gift_card_front_image') ? 'https:' + this.getAttribute('gift_card_front_image') : null,
                pdfCode: pdfCode,
                returnUrl: true
            };
            
            const fetchPromise = fetch('https://puppeteer-cgl.personify.tech/api/polotno2pdf-cgl', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });
            
            if (window.trackFetchRequest) {
                window.trackFetchRequest(
                    fetchPromise, 
                    `Gift card PDF generation for product ${productId} with code ${pdfCode}`,
                    payload
                );
            } else {
                window.pendingGiftCardFetches = window.pendingGiftCardFetches || [];
                window.pendingGiftCardFetches.push(fetchPromise);
                
                fetchPromise.catch(error => {
                    console.error('Error generating PDF:', error);
                    
                    if (window.sendTelegramError) {
                        window.sendTelegramError(
                            error, 
                            `Gift card PDF generation (fallback) for product ${productId} with code ${pdfCode}`,
                            payload
                        );
                    }
                });
            }
        }

        try {
            console.log('Adding product to cart with properties:', properties);
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: Number(this.getAttribute('variant_id')),
                        quantity: 1,
                        properties: properties
                    }]
                })
            });

            const data = await response.json();
            this.updateCartCount();
            this.updateCartSummary();

            const currentProductId = Number(this.getAttribute('product_id'));
            console.log('Current product ID that was added to cart:', currentProductId);
            
            const upsellPopup = document.querySelector('gift-love-upsell-popup');
            if (upsellPopup && typeof upsellPopup.markProductAsAdded === 'function') {
                console.log('Marking current product as added in the parent popup');
                upsellPopup.markProductAsAdded(currentProductId);
            }
            
            if (this.onProductAdded) {
                console.log('Calling onProductAdded callback before dispatching cart:add-complete with keepPopup=true');
                this.onProductAdded(currentProductId, true);
            }
            
            console.log('Removing product detail popup after adding to cart');
            this.remove();
            
            console.log('Dispatching cart:add-complete event with product ID:', currentProductId);
            document.dispatchEvent(new CustomEvent('cart:add-complete', {
                detail: { productId: currentProductId }
            }));
            
            // If this is a gift card product, automatically proceed to upsell products
            if (isGiftCard && window.showUpsellPopup && typeof window.showUpsellPopup === 'function') {
                console.log('Automatically proceeding to upsell products after adding gift card');
                setTimeout(() => {
                    window.showUpsellPopup();
                }, 500);
            }
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    }

    updateCartCount = async () => {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            const cartCount = cart.item_count;
            const cartCountElements = document.querySelectorAll('.header-cart__count');
            if (cartCountElements) {
                cartCountElements.forEach(element => {
                    element.textContent = cartCount;
                });
            }
        } catch (error) {
            console.error('Error updating cart count:', error);
        }
    }

    updateCartSummary = async () => {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            
            const cartSummary = document.querySelector('.cart-summary');
            if (!cartSummary) return;

            const summaryResponse = await fetch('/?section_id=header');
            const html = await summaryResponse.text();
            
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            const newCartSummary = doc.querySelector('.cart-summary');
            if (newCartSummary) {
                cartSummary.innerHTML = newCartSummary.innerHTML;
            }
        } catch (error) {
            console.error('Error updating cart summary:', error);
        }
    }

    renderContainerStyle = () => {
        return `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000001;
            background-color: rgba(0, 0, 0, 0.62);
        `;
    }

    renderStyle = () => {
        return `
            <style>
                @import url('${this.getAttribute("css")}');
                @import url('https://fonts.googleapis.com/css2?family=Karla:wght@400;700&display=swap');

                .loading-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 40px 20px;
                    text-align: center;
                    min-height: 200px;
                }

                .loading-spinner {
                    width: 40px;
                    height: 40px;
                    border: 3px solid rgba(0, 0, 0, 0.1);
                    border-top: 3px solid #000;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 15px;
                }

                .loading-text {
                    font-size: 14px;
                    color: #666;
                    margin: 0;
                    font-family: Karla, sans-serif;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .popup-container {
                    background: white;
                    padding: 40px;
                    border-radius: 8px;
                    max-width: 800px;
                    width: 90%;
                    position: relative;
                    max-height: 90vh;
                    overflow-y: auto;
                }

                .product-detail {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 20px;
                }

                .close-button {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                }

                img {
                    width: 100%;
                    height: auto;
                }

                .form-group {
                    margin-bottom: 15px;
                }

                label {
                    display: block;
                    margin-bottom: 5px;
                }

                input, textarea {
                    width: 100%;
                    padding: 8px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                }

                .add-to-cart-button {
                    background: #000;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    width: 100%;
                    font-size: 14px;
                    text-transform: uppercase;
                }

                .add-to-cart-button:hover {
                    opacity: 0.9;
                }

                .continue-shopping {
                    display: block;
                    text-align: center;
                    margin-top: 40px;
                    font-size: 20px;
                    color: #000;
                    text-decoration: underline;
                    cursor: pointer;
                }

                .quantity-selector select {
                    width: 100%;
                    padding: 8px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    background-color: white;
                    cursor: pointer;
                }

                .quantity-selector {
                    margin-bottom: 20px;
                }

                input, textarea, select {
                    box-sizing: border-box;
                    background-color: transparent;
                    color: inherit;
                    border: 1px solid #bfbfbf;
                    border-radius: 0;
                    font-family: Karla, sans-serif;
                    font-weight: 400;
                    font-style: normal;
                    line-height: 1.4em;
                    max-width: 100%;
                    padding: 12px 15px;
                    margin: 5px 5px 5px 0;
                }

                select {
                    width: 100%;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    background-position: right center;
                    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' stroke='%23000000' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
                    background-repeat: no-repeat;
                    background-position: right 8px center;
                    background-color: transparent;
                    background-size: 18px;
                    padding-right: 28px;
                    text-indent: 0.01px;
                    text-overflow: "";
                    cursor: pointer;
                }

                select::-ms-expand {
                    display: none;
                }

                @media screen and (max-width: 767px) {
                    .popup-container {
                        padding: 20px;
                        width: 95%;
                        margin: 20px;
                    }
                    
                    .product-detail {
                        grid-template-columns: 1fr;
                    }

                    .close-button {
                        top: 5px;
                        right: 5px;
                    }

                    .continue-shopping {
                        margin-top: 20px;
                        font-size: 16px;
                    }

                    #product-image {
                        width: 100%;
                        transition: width 0.3s ease;
                        margin: 0 auto;
                        display: block;
                    }

                    #product-image.shrink-image {
                        width: 50%;
                    }

                    .loading-container {
                        padding: 20px;
                        min-height: 150px;
                    }
                }

                @media screen and (max-width: 480px) {
                    .popup-container {
                        padding: 15px;
                    }

                    .form-group {
                        margin-bottom: 10px;
                    }

                    input, textarea, select {
                        padding: 8px 12px;
                    }

                    .add-to-cart-button {
                        background-color: black;
                        color: white;
                        height: 43px;
                        width: 100%;
                        border-radius: 0;
                        cursor: pointer;
                        text-align: center;
                        margin-top: 5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 0;
                    }

                    .loading-spinner {
                        width: 30px;
                        height: 30px;
                    }

                    .loading-text {
                        font-size: 13px;
                    }
                }
                input, textarea, select {
                    font-size: 17px !important;
                    max-height: 100%;
                }

                @supports (-webkit-touch-callout: none) {
                    input, textarea, select {
                        font-size: 17px !important;
                    }
                }

                .message-preview-container {
                    margin-bottom: 20px;
                }

                .message-preview {
                    background: #FFFFFF;
                    border: 1px solid #E5E5E5;
                    border-radius: 4px;
                    width: ${PAGE_WIDTH}px;
                    height: ${PAGE_HEIGHT}px;
                    margin: 0 auto;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .editable-content {
                    width: 100%;
                    height: auto;
                    max-height: 100%;
                    padding: ${SIDE_MARGIN}px;
                    font-family: 'Karla', sans-serif;
                    font-size: 16px !important;
                    line-height: ${LINE_HEIGHT}px;
                    text-align: center;
                    white-space: pre-wrap;
                    word-break: break-word;
                    outline: none;
                    overflow-y: auto;
                    position: relative;
                    -webkit-text-size-adjust: 100%;
                    text-size-adjust: 100%;
                    transform: scale(1);
                    transform-origin: top left;
                }

                .editable-content:empty:before {
                    content: attr(data-placeholder);
                    color: #999;
                    font-style: italic;
                    font-family: Karla, sans-serif;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: calc(100% - ${2 * SIDE_MARGIN}px);
                    pointer-events: none;
                }

                @supports (-webkit-touch-callout: none) {
                    .editable-content {
                        font-size: 16px !important;
                        transform: scale(1);
                        -webkit-text-size-adjust: none;
                    }
                }

                input[type="text"],
                select {
                    font-size: 16px !important;
                    -webkit-text-size-adjust: 100%;
                    -webkit-touch-callout: none;
                }

                .popup-container {
                    -webkit-text-size-adjust: none;
                    -webkit-touch-callout: none;
                }

                .message-input {
                    display: none;
                }

                .preview-content {
                    display: none;
                }

                .character-count {
                    text-align: right;
                    font-size: 12px;
                    color: #666;
                    margin-top: 4px;
                }

                /* iOS-specific styles */
                @supports (-webkit-touch-callout: none) {
                    .message-preview {
                        transform: scale(1);
                        -webkit-text-size-adjust: none;
                    }

                    input[type="text"],
                    textarea,
                    select {
                        font-size: 16px !important;
                        transform: scale(1);
                        -webkit-text-size-adjust: none;
                    }
                }

                /* Prevent zoom on focus for iOS */
                @media screen and (max-width: 767px) {
                    input[type="text"],
                    textarea,
                    select,
                    .editable-content {
                        font-size: 16px !important;
                        -webkit-text-size-adjust: none;
                    }
                }
            </style>
        `;
    }
}

customElements.define('gift-love-upsell-product-detail', GiftLoveUpsellProductDetail);